/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/*
 * A directive that will customize the a checkbox to make it more of a bulb style.
 * In order to use correctly: create an input of type checkbox and append the directive as an attribute
 * Then create a label as a direct sibling of the input
 */
angular.module('bulbApp.checkboxModule')
.directive('bulbCheckbox', bulbCheckbox);

function bulbCheckbox() {
  return {
    restrict: 'A',
    replace: true,
    compile: function() {

      return {
        pre: function(scope, element, attrs){

          element.wrap('<label class="bulb-checkbox"></label>');
          element.parent().append('<div class="custom-checkbox"></div>');
        }
      };
    }
  };
}
